import React from "react";

export const AdminPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: "/admin",
      exact: true,
      component: React.lazy(() => import("./Admin")),
    },
  ],
};
